module.exports = __webpack_public_path__ + "img/user-cropper.e4f80396.svg";